const aboutData = [
    {
        id: 1,
        imgName: "/coding.png",
        title: "Problem Solving Interview",
        data: "Data Structures and Algorithms are the most important concepts for technical interviews. Our Mock Interviews consists of challenging DSA problems to be solved in a given time."
    },
    {
        id: 2,
        imgName: "/resume.png",
        title: "Resume and Project Discussion",
        data: "Being through of your resume and projects are really important for the interviews. Many of the big techs ask questions related to your project and internships, so we got you covered in this too."
    },
    {
        id: 3,
        imgName: "/web-design.png",
        title: "System Design Interview",
        data: "System design interviews are becoming really popular for interviews. These interviews will help you to understand how large scale distributed systems are designed."
    },
    {
        id: 4,
        imgName: "/satisfaction.png",
        title: "Complete Feedback",
        data: "We provide you complete feedback. Your plus, minus, what you should focus on, what are your weak topics and other important stuffs."
    },
    {
        id: 5,
        imgName: "/seo.png",
        title: "Preparation Guidelines",
        data: "We promise you to provide you complete guidelines for your improvement. Your daily routine for practicing coding and provide you link to resources."
    },
    {
        id: 6,
        imgName: "/love.png",
        title: "Handpicked Problems",
        data: "With our own experience we have tried to pick best problems from various coding platform which will help you to gain a proper insight about your preparation."
    }
];

export default aboutData;